// extracted by mini-css-extract-plugin
export var folderAnimation = "header-module--folder-animation--3be92";
export var folderBackLeft = "header-module--folder-back-left--38550";
export var folderBackRight = "header-module--folder-back-right--e95b9";
export var folderFrontLeft = "header-module--folder-front-left--cc3e2";
export var folderFrontRight = "header-module--folder-front-right--2e397";
export var folderchange = "header-module--folderchange--4ec3e";
export var headerMain = "header-module--header-main--d7abf";
export var mainTitle = "header-module--main-title--62005";
export var pageTitleContainer = "header-module--page-title-container--a2fab";
export var paper = "header-module--paper--8dd19";